<template>
  <div class="home">
    <v-alert type="success" v-if="hasOnlineSubscription">
      Du har en aktiv prenumeration till {{user.end_date | moment("Do MMMM YYYY")}}
    </v-alert>
    <div v-else>
    <v-alert type="info" v-if="!hasOnlineSubscription">
      Du har ingen aktiv prenumeration. För att uppgradera, välj ett av alternativen nedan:
    </v-alert>
    <v-row no-gutters>
      <v-card
        class="mx-auto rounded-t-xl md-6 xs-12"
        max-width="600"
        outlined
        color="rgba(220, 220, 220, 0.9)"
        elevation=4
      >
        <v-list-item three-line>
          <v-list-item-content>
            <div class="overline mb-4">Windows</div>
            <v-list-item-title class="headline mb-1">Hjälp På Traven Pro + Online</v-list-item-title>
            <v-list-item-subtitle>Det kraftfullaste och modernaste programmet för att bygga reducerade travsystem för ATGs streckspel som finns på marknaden</v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-avatar
            tile
            size="80"
            color="grey"
          ></v-list-item-avatar>
        </v-list-item>

        <v-chip
          v-for="(feature,index) in hptProFeatures"
          :key="`reduction-${index}`"
          class="ma-2"
          color="teal"
          text-color="white"
          small
        >
          <v-avatar left>
            <v-icon>mdi-checkbox-marked-circle</v-icon>
          </v-avatar>
          {{feature}}
        </v-chip>
        <br/>
        <v-chip
          v-for="(feature,index) in hptProFeaturesMisc"
          :key="`misc-${index}`"
          class="ma-2"
          color="blue"
          text-color="white"
          small
        >
          <v-avatar left>
            <v-icon>mdi-checkbox-marked-circle</v-icon>
          </v-avatar>
          {{feature}}
        </v-chip>

        <v-card-actions>
          <v-img contain height="55" src="https://www.payson.se/sites/all/files/images/external/Ikon_betalsatt_150x55_3_trans_bank.png" />
          <v-btn
            target="_blank"
            href="https://www.payson.se/myaccount/pay?De=Tre+m%e5naders+HPT+Online+och+PRO&Se=online%40hpt.nu&Cost=149%2c00&Currency=SEK&Sp=1&Lang=SE"
          >
            3 mån 149:-
          </v-btn>
          <v-btn
            target="_blank"
            href="https://www.payson.se/myaccount/pay?De=Ett+%e5rs+HPT+Online+och+PRO&Se=online%40hpt.nu&Cost=449%2c00&Currency=SEK&Sp=1&Lang=SE"
          >
            1 år 449:-
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card
        class="mx-auto rounded-t-xl package-card md-6 xs-12"
        max-width="600"
        outlined
        color="rgba(220, 220, 220, 0.9)"
        elevation=4
      >
        <v-list-item three-line>
          <v-list-item-content>
            <div class="overline mb-4">Onlinetjänst</div>
            <v-list-item-title class="headline mb-1">Hjälp På Traven Online</v-list-item-title>
            <v-list-item-subtitle>Få tillgång till en stor del av kärnan i HPT Pro genom ett smidigt webb-gränssnitt. Fungerar på samtliga enheter!</v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-avatar
            tile
            size="80"
            color="grey"
          ></v-list-item-avatar>
        </v-list-item>

        <v-chip
          v-for="(feature,index) in hptOnlineFeatures"
          :key="`reductiononline-${index}`"
          class="ma-2"
          color="teal"
          text-color="white"
          small
        >
          <v-avatar left>
            <v-icon>mdi-checkbox-marked-circle</v-icon>
          </v-avatar>
          {{feature}}
        </v-chip>
        <br/>
        <v-chip
          v-for="(feature,index) in hptOnlineFeaturesMisc"
          :key="`misconline-${index}`"
          class="ma-2"
          color="blue"
          text-color="white"
          small
        >
          <v-avatar left>
            <v-icon>mdi-checkbox-marked-circle</v-icon>
          </v-avatar>
          {{feature}}
        </v-chip>

        <v-card-actions>
          <v-img contain height="55" src="https://www.payson.se/sites/all/files/images/external/Ikon_betalsatt_150x55_3_trans_bank.png" />
          <v-btn
            target="_blank"
            href="https://www.payson.se/SendMoney/?De=HPT+Online+till+introduktionspris&amp;Se=online%40hpt.nu&amp;Cost=49%2c00&amp;Currency=SEK&amp;&amp;Sp=1"
          >
            40 dagar 49:-
            </v-btn>
            <v-btn
            target="_blank"
            href="https://www.payson.se/myaccount/pay?De=Tre+m%e5naders+HPT+Online&Se=online%40hpt.nu&Cost=99%2c00&Currency=SEK&Sp=1&Lang=SE"
          >
            3 mån 99:-
          </v-btn>
          <v-btn
            target="_blank"
            href="https://www.payson.se/myaccount/pay?De=Ett+%e5rs+HPT+Online&Se=online%40hpt.nu&Cost=299%2c00&Currency=SEK&Sp=1&Lang=SE"
          >
            1 år 299:-
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-row>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'home',

  components: {
  },

  data: () => ({
    hptProFeatures: ['ABCDEF', 'Kusk', 'Tränare', 'Utgångar', 'Ranksumma', 'Radvärde', 'Spårsumma', 'Streckprocent'],
    hptProFeaturesMisc: ['Flerbong', 'V6/V7', 'V4/V5', 'DD/LD/Tvilling/Trio', 'Egna mallar', 'Skapa bolag med mailfunktion', 'Rätta i mobilen', 'Kommentarer/nästagångare', 'Dela system med andra'],
    hptOnlineFeatures: ['ABCD', 'Utgångar', 'Egen ranksumma', 'Radvärde', 'Spårsumma'],
    hptOnlineFeaturesMisc: ['Flerbong', 'V6', 'V4/V5', 'Spela på dator eller mobil', 'Dela system med andra']
  }),

  mounted () {
    if (!this.isLoggedIn) {
      // this.$router.push('/login')
    }
  },

  computed: {
    ...mapGetters(['username', 'isLoggedIn', 'hasOnlineSubscription', 'user'])
  }
}
</script>
